export default __webpack_public_path__ + "static/media/cases2.855b02a7.jpg";